import { publicEnv } from "@/config/publicEnv";

function getBaseUrl() {
  return publicEnv.NEXT_PUBLIC_BASE_URL || "http://localhost:3000";
}

export function getRpcApiPath(chainId: number | string) {
  return `${getBaseUrl()}/api/rpc-proxy/${chainId}`;
}
